var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_62_2098)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.96 12.0007L23.3847 4.57603C24.205 3.75568 24.205 2.42568 23.3847 1.60661L22.3949 0.616803C21.5743 -0.203807 20.2443 -0.203807 19.4252 0.616803L12.0007 8.04126L4.57603 0.615265C3.75568 -0.205088 2.42568 -0.205088 1.60661 0.615265L0.615265 1.60507C-0.205088 2.42568 -0.205088 3.75568 0.615265 4.57475L8.04126 12.0007L0.616803 19.4252C-0.203807 20.2458 -0.203807 21.5758 0.616803 22.3949L1.60661 23.3847C2.42696 24.205 3.75696 24.205 4.57603 23.3847L12.0007 15.96L19.4252 23.3847C20.2458 24.205 21.5758 24.205 22.3949 23.3847L23.3847 22.3949C24.205 21.5743 24.205 20.2443 23.3847 19.4252L15.96 12.0007Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_62_2098"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconClose);
export default __webpack_public_path__ + "static/media/icon-close.7405561452458ccc58fb408192d083c6.svg";
export { ForwardRef as ReactComponent };